import { render, staticRenderFns } from "./c-player__video.vue?vue&type=template&id=437206e3&scoped=true"
import script from "./c-player__video.vue?vue&type=script&lang=js"
export * from "./c-player__video.vue?vue&type=script&lang=js"
import style0 from "./c-player__video.vue?vue&type=style&index=0&id=437206e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437206e3",
  null
  
)

export default component.exports